import type { ISpamDisposition } from '@/types';

export const isHighConfidenceSpam = (
  disposition?: Pick<ISpamDisposition, 'label' | 'confidence'> | null,
) => disposition?.label === 'spam' && disposition.confidence === 'high';
